import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: 'en',
    resources: {
      en: {
        translation: {
          WCD: 'Waste collection days',
          title: `Find out your waste<br/> collection day`,
          subTitle: 'Check when your waste will be collected.',
          enterPostcode: 'Enter a postcode',
          forExample: 'For example',
          findPostcodeOn: "Find a postcode on Royal Mail's postcode finder",
          RelatedContent: 'Related content',
          addToYourCalendar: 'Add to your calendar',
          viewAndDownload: 'View and download printable schedule',
          selectAddress: 'Select an address',
          pleaseSelectAddress: 'Please select address',
          clearAddress: 'Clear address and start again',
          yourNextCollection: 'Your next collections',
          followedBy: 'followed by',
          noCollectionWarning: 'There are no upcoming collections scheduled for the above address.',
          help: 'Help',
          cookies: 'Cookies',
          contact: 'Contact',
          accessibility: 'Accessibility Statement',
          privacyPolicy: 'Privacy Policy',
          find: 'Find',
          downloadCalendar: 'Download calendar',
          back: 'Back',
          collectionFor: 'Collection for',
          year: 'Year',
          month: 'Month',
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          May: 'May',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Oct',
          nov: 'Nov',
          dec: 'Dec',
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
          january: 'January',
          february: 'February',
          march: 'March',
          april: 'April',
          may: 'May',
          june: 'June',
          july: 'July',
          august: 'August',
          september: 'September',
          october: 'October',
          november: 'November',
          december: 'December',
          errorMSG: 'The postcode entered appears to be incorrect. Provide a valid postcode to continue.',
          warning: 'Warning',
        },
      },
      cy: {
        translation: {
          WCD: 'Diwrnodau Casglu Gwastraff',
          title: `Canfod diwrnod casglu <br/> eich gwastraff`,
          subTitle: 'Gwirio pryd y caiff eich gwastraff ei gasglu.',
          enterPostcode: 'Rhowch god post',
          forExample: 'Er enghraifft',
          findPostcodeOn: 'Canfod cod post ar ganfyddwr cod post Post Brenhinol',
          RelatedContent: 'Post Brenhinol',
          addToYourCalendar: 'rhoi ar eich calendr',
          viewAndDownload: 'gweld a lawrlwytho rhaglen y gellir ei hargraffu',
          selectAddress: 'dewis cyfeiriad',
          pleaseSelectAddress: 'dewiswch gyfeiriad os gwelwch yn dda',
          clearAddress: 'clirio cyfeiriad a dechrau eto',
          yourNextCollection: 'eich casgliadau nesaf',
          followedBy: 'dilynir gan',
          noCollectionWarning: 'Nid oes unrhyw gasgliadau ar y gwwill ar gyfer y cyfeiriad uchod.',
          help: 'Help',
          cookies: 'Cwcis',
          contact: 'Cyswllt',
          accessibility: 'Datganiad Hygyrchedd',
          privacyPolicy: 'Polisi Preifatrwydd',
          find: 'Canfod',
          downloadCalendar: 'Lawrlwytho calendr',
          back: 'Nôl',
          collectionFor: 'Casgliad ar gyfer',
          year: 'Blwyddyn',
          month: 'Mis',
          jan: 'Ion',
          feb: 'Chwef',
          mar: 'Maw',
          apr: 'Ebr',
          May: 'Mai',
          jun: 'Meh',
          jul: 'Gorff',
          aug: 'Awst',
          sep: 'Medi',
          oct: 'Hyd',
          nov: 'Tach',
          dec: 'Rhag',
          monday: 'Dydd Llun',
          tuesday: 'Dydd Mawrth',
          wednesday: 'Dydd Mercher',
          thursday: 'Dydd Gwener',
          friday: 'Dydd Gwener',
          saturday: 'Dydd Sadwrn',
          sunday: 'Dydd sul',
          january: 'Ionawr',
          february: 'Chwefror',
          march: 'Mawrth',
          april: 'Ebrill',
          may: 'Mai',
          june: 'Mehefin',
          july: 'Gorffennaf',
          august: 'Awst',
          september: 'Medi',
          october: 'Hydref',
          november: 'Tachwedd',
          december: 'Rhagfyr',
          errorMSG: "Mae'r cod post a roddwyd yn ymddangos yn anghywir. Rhowch god post dilys i barhau.",
          warning: 'Rhybudd',
        },
      },
    },
  });
